import React from "react";

export default function ResultScreen({ result, questionIndex, totalScore, onNext, onExit }) {
  if (!result) return null;
  const isCorrect = result.correct === result.user;

  return (
    <div className="result-screen">
      
      {/* HEADER */}
      <div className={`result-header ${isCorrect ? "success" : "danger"}`}>
        <h1>{isCorrect ? "CORRECT!" : "INCORRECT!"}</h1>
      </div>

      {/* OVERLAPPING ICON */}
      <div className="result-icon-wrapper">
        <div className={`result-icon-circle ${isCorrect ? "success" : "danger"}`}>
          {isCorrect ? "✔" : "✖"}
        </div>
      </div>

      {/* CONTENT AREA */}
      <div className="exercise" style={{ marginTop: 0 }}>
        
        <div className="config-card result-card">
          <div className="config-title">Question {questionIndex}</div>

          <div className="row">
            <span className="expression-text">{result.expression} =</span>
            <span className="result-val">{result.correct}</span>
          </div>

          <div className="row highlight">
            <span>Your Answer</span>
            <span className="result-val">{result.user}</span>
          </div>

          <div className="row">
            <span>Score</span>
            <span className="result-val">{totalScore}/{questionIndex}</span>
          </div>
        </div>

        <div className="button-group">
          <button className="btn-primary" onClick={onNext}>
            Next Question
          </button>
          <button 
            className="btn-primary" 
            onClick={onExit}
            style={{ marginTop: "15px" }}
          >
            Exit
          </button>
        </div>

      </div>

    </div>
  );
}